// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dzInputContainer {
    position: relative;
    z-index: 1;
}

.dz-hidden-input {
    overflow: hidden !important;
}

.adminPrimaryBtnBaseDropZoneContainer .filepicker,
.adminSecondaryBtnBaseDropZoneContainer .filepicker {
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 20px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 45px;
    -webkit-box-shadow: none;
    box-shadow: none;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
}


.adminPrimaryBtnBaseDropZoneContainer .filepicker {
    background-color: var(--primary-bg);
    border-color: var(--primary-bg);
    color: var(--common-primary-white-foreground);
}

.adminSecondaryBtnBaseDropZoneContainer .filepicker {
    background-color: transparent;
    border: 1px solid var(--primary-bg);
    color: var(--primary-bg);
}

.adminPrimaryBtnBaseDropZoneContainer .filepicker .dz-message,
.adminSecondaryBtnBaseDropZoneContainer .filepicker .dz-message {
    display: none;
}

.adminPrimaryBtnBaseDropZoneContainer .dz-hidden-input,
.adminSecondaryBtnBaseDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

.uploadNotifyText {
    color: var(--secondary-foreground);
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    margin: 12px 0 0;
    text-align: center;
}

/* profile dropzone start */

.profileUploaderBtn {
    position: absolute;
    bottom: 8px;
    right: 2px;
    cursor: pointer;
    z-index: 5;
}

.profileEditIcon {
    position: relative;
    z-index: -1;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px #0000001A;
}

.rtl .profileUploaderBtn {
    left: 2px;
    right: auto;
}

/* profile dropzone end */`, "",{"version":3,"sources":["webpack://./src/styles/adminDropzone.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,2BAA2B;;AAE3B;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA,yBAAyB","sourcesContent":[".dzInputContainer {\n    position: relative;\n    z-index: 1;\n}\n\n.dz-hidden-input {\n    overflow: hidden !important;\n}\n\n.adminPrimaryBtnBaseDropZoneContainer .filepicker,\n.adminSecondaryBtnBaseDropZoneContainer .filepicker {\n    min-height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 7px 20px;\n    font-size: 18px;\n    font-weight: 600;\n    border-radius: 45px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    line-height: 28px;\n    text-align: center;\n    cursor: pointer;\n}\n\n\n.adminPrimaryBtnBaseDropZoneContainer .filepicker {\n    background-color: var(--primary-bg);\n    border-color: var(--primary-bg);\n    color: var(--common-primary-white-foreground);\n}\n\n.adminSecondaryBtnBaseDropZoneContainer .filepicker {\n    background-color: transparent;\n    border: 1px solid var(--primary-bg);\n    color: var(--primary-bg);\n}\n\n.adminPrimaryBtnBaseDropZoneContainer .filepicker .dz-message,\n.adminSecondaryBtnBaseDropZoneContainer .filepicker .dz-message {\n    display: none;\n}\n\n.adminPrimaryBtnBaseDropZoneContainer .dz-hidden-input,\n.adminSecondaryBtnBaseDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n.uploadNotifyText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: normal;\n    margin: 12px 0 0;\n    text-align: center;\n}\n\n/* profile dropzone start */\n\n.profileUploaderBtn {\n    position: absolute;\n    bottom: 8px;\n    right: 2px;\n    cursor: pointer;\n    z-index: 5;\n}\n\n.profileEditIcon {\n    position: relative;\n    z-index: -1;\n    border-radius: 50%;\n    box-shadow: 0px 4px 4px 0px #0000001A;\n}\n\n.rtl .profileUploaderBtn {\n    left: 2px;\n    right: auto;\n}\n\n/* profile dropzone end */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
